import { render, staticRenderFns } from "./ExplanationModal.vue?vue&type=template&id=37ae4cef&scoped=true&"
import script from "./ExplanationModal.vue?vue&type=script&lang=js&"
export * from "./ExplanationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae4cef",
  null
  
)

export default component.exports